import Vue from "vue";
import Vuetify from "vuetify/lib";
import fa from "vuetify/lib/locale/fa";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fa },
    current: "fa",
    rtl: {
      fa: true,
    },
  },

  rtl: true,
  theme: {
    themes: {
      light: {
        primary: "#e0218a",
        secondary:"#d02cf6",
        light:"#f098f9",
        whiteColor: "#F2F2F2",
        blackColor: "#707070",
        grayColor: "#ECECEC",
      },
    },
  },
});
